import { lazy, useMemo } from "react";
import '../util/dateUtils';
import { useAppContext } from "../contexts/AppContext";

const TapolyV2 = lazy(() => import("./installations/TapolyV2"));
const TapolyAI = lazy(() => import("./installations/TapolyAI"));
const TapolyAIDemo = lazy(() => import("./installations/TapolyAIDemo"));
const UKAndI = lazy(() => import("./installations/UKAndI"));
const ExampleInstallation = lazy(() => import("./installations/ExampleInstallation"));

const Home = () => {
    const { branding } = useAppContext();

    switch (branding?.installation) {
        case "Tapoly": return <TapolyV2 />
        case "Tapoly-AI": return <TapolyAI />
        case "Tapoly-AI-Demo": return <TapolyAIDemo />
        case "UK&I": return <UKAndI />
        case "Example": return <ExampleInstallation />

        default:
            return null;
    }
};

export default Home;
